<template>
  <div class="filter" 
    :class="{'optional': !filter.required}">
        {{filter.label}} 
      <span class="fa-stack remove" 
        @click="$emit('removeFilter',filter.key)" 
        v-if="!filter.required">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-times fa-stack-1x"></i>
      </span>
  </div>
</template>

<script>
export default {
  name: 'FilterItem',
  props:["filter"],
  emits: ['removeFilter']
}
</script>

<style scoped>

.filter{
  border: 1px solid black;
  font-family: "Montserrat";
  margin-right: 25px;
  padding: 5px 15px;
  border-radius: 5px;
  margin-bottom: 20px;
  font-size: 16px;
}

.filter.optional {
  padding-right: 5px;
}

.filter:hover{
  cursor: pointer;
}

span.remove{
  font-size: 13px;
  margin-left: 10px;
}

span.remove:hover{
  opacity: 0.7;
}

i.pencil{
  color: #1976d2;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

i.pencil span{
  font-family: "Montserrat";
  margin-left: 5px;
  font-family: Montserrat Semibold;
  font-size: 14px;
  color: #1976d2;
}

i.pencil:hover{
  cursor: pointer;
}

i.fa-circle{
  color: #ccc;
}

i.fa-times{
  color: #5C5E60;
}
</style>